import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ISubject } from '../../../core/models/subject';

interface NewSubjectState {
  subjects: ISubject[];
  selectedSubjects: string[];
  selectOptions: { label:string, value: string }[];
  setSelectOptions: (options: { label:string, value: string }[]) => void;
  setSubjects: (subjects: ISubject[]) => void;
  setSelectedSubjects: (subjects: string[]) => void;
  resetFilterSubject: () => void;
  resetSubjects: () => void;
}

export const useNewSubjectStore = create<NewSubjectState>()(
  persist(
    (set) => ({
      subjects: [],
      selectedSubjects: [],
      selectOptions: [],
      setSelectOptions: (options: { label:string, value: string }[]) => set({ selectOptions: options }),
      setSubjects: (subjects: ISubject[]) => set({ subjects }),
      setSelectedSubjects: (subjects: string[]) => set({ selectedSubjects: subjects }),
      resetFilterSubject: () => set({ selectedSubjects: [] }),
      resetSubjects: () => set({ subjects: [], selectedSubjects: [] })
    }),
    {
      name: 'new-discipline-subject',
    }
  )
);